module.exports = __webpack_public_path__ + "static/merck-sharp-and-dohme-00-hero-587b3674dbb85b36b467601efd38792c.jpg";